export default __webpack_public_path__ + "58825dbddaa3634c21c899c724c5fe2b.mp3";